import { CSSProperties } from 'react';

const KariusLogoFooter = (props: { style?: CSSProperties; classNameName?: string }) => (
  <div {...props}>
    <svg
      id='logo_svg__Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 393.7 68.4'
      {...props}
    >
      <defs>
        <style>{'.logo_svg__cls-1{fill:#fff}.logo_svg__cls-2{fill:#f05d24}'}</style>
      </defs>
      <path
        className='logo_svg__cls-1'
        d='M378 28.8c-6.8-2.4-12.7-4.1-12.7-9.1 0-4.4 3.8-7.4 9.7-7.4a15.8 15.8 0 019.1 2.4 8.22 8.22 0 004.7 1.5c2.9 0 5-2.9 5-5.6 0-5.3-8.3-8.8-19.2-8.8-13.9 0-21.2 10.6-21.2 18.6 0 13.3 11.5 16.5 20.6 19.2 7.1 2.1 13 3.8 13 9.1a9.82 9.82 0 01-2.9 7.1c-2.4 2.4-6.2 3.8-10.6 3.8-5.3 0-8.8-1.8-11.5-2.9a10.86 10.86 0 00-4.4-1.5c-2.9 0-5 2.1-5 5.3 0 5.6 10.9 9.4 20.9 9.4 15.3 0 25.1-8.3 25.1-21.8 0-13.1-11.5-16.6-20.6-19.3zM239.1 2.3a6 6 0 00-5.9 5.9V64a5.9 5.9 0 0011.8 0V8.2a5.91 5.91 0 00-5.9-5.9zM133.8 61.8L111 6.4a6 6 0 00-3.5-3.5 3.81 3.81 0 00-1.8-.3h-.6a3.81 3.81 0 00-1.8.3 5.6 5.6 0 00-3.2 3.2c-.3 0-.3 0-.3.3L77.1 61.8a6.05 6.05 0 003.2 7.7 5.11 5.11 0 002.1.3A6.08 6.08 0 0088 66l17.4-42.2L122.8 66a5.66 5.66 0 005.6 3.8 4.45 4.45 0 002.1-.3 6.06 6.06 0 003.3-7.7z'
        transform='translate(-4.9 -1.7)'
      />
      <path
        className='logo_svg__cls-2'
        d='M53.5 4c-2.3-2-6.2-2-8.2.3L16.6 34.7V8.2a6 6 0 00-5.9-5.9 5.83 5.83 0 00-5.8 5.9V64a6 6 0 005.9 5.9 6 6 0 005.9-5.9V51.8l37.2-39.5a5.77 5.77 0 00-.4-8.3zM55.3 59.8L41.1 45.3a5.87 5.87 0 00-8.3 8.3L46.7 68a6 6 0 004.4 1.8 5.7 5.7 0 004.1-1.8c2.5-2 2.5-5.6.1-8.2z'
        transform='translate(-4.9 -1.7)'
      />
      <path
        className='logo_svg__cls-1'
        d='M323.7 2.3a6 6 0 00-5.9 5.9v34.2c0 10.9-8.6 15.6-17.1 15.6s-17.1-5-17.1-15.6V8.2a5.9 5.9 0 00-11.8 0v34.2c0 18 14.7 27.7 28.9 27.7 14.5 0 28.9-9.4 28.9-27.7V8.2a5.85 5.85 0 00-5.9-5.9zM208.4 60.1l-18.6-19.2c12.4-3.2 17.4-13.3 16.5-21.8-.9-8.8-7.4-17.4-18.6-17.4h-26.5a6 6 0 00-5.9 5.9v56.6a5.9 5.9 0 0011.8 0v-51h20.6c3.8 0 5.6 3.2 5.9 5.9a8.72 8.72 0 01-6.5 10c-5.6 1.8-11.5 4.1-12.4 8.6-.6 2.7.9 5.6 4.4 8.8l21 21.5a5.88 5.88 0 004.1 1.8 7.12 7.12 0 004.1-1.5 5.92 5.92 0 00.1-8.2z'
        transform='translate(-4.9 -1.7)'
      />
    </svg>
  </div>
);

export default KariusLogoFooter;
